export const deviceCheck = () => {
	if (typeof window === "undefined") return null;

	const isiOS = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
	const isMacOS = /macintosh/.test(window.navigator.userAgent.toLowerCase());
	const isDesktopOrLaptop = window.matchMedia("(min-width: 1024px)").matches;
	const isStandalone = "standalone" in window.navigator && window.navigator.standalone;

	const deviceType = isiOS ? "iOS" : isMacOS || isDesktopOrLaptop ? "MacOS" : "other";

	return { valid: (isiOS || isMacOS) && !isStandalone, deviceType };
};
